import { Slider } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceSlider",
  //extends: Slider,
  mixins: [Slider, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    sliderDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
